/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";

import * as shape from "d3-shape";
import {IErrorObject} from "../../../../../types/platform/universe";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MessageDialogComponent} from "../../base/components/message-dialog/message-dialog.component";
import {ShotScoreService} from "../shot-score.service";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

/**
 * todo
 */
@Component({
	selector: "aigia-posture-chart",
	templateUrl: "./posture-chart.component.html",
	styleUrls: ["../floating/floating.component.css", "./posture-chart.component.css"],
})
export class PostureChartComponent extends FloatingComponent implements OnInit, OnChanges {

	@Input() public locked: boolean;
	@Input() public width: number;
	@Input() public height: number;
	@Input() public shots: any[];
	@Input() public size: number[];
	@Input() public criterion: boolean;
	@Input() public maxSelected: number;

	public modename: string;
	public modestyle: any;

	public progress: boolean = false;

	public title: string = "Posture Chart";

	public lineCharts: any = [];
	public lineChartsSelected: any[] = [];

	public selected: number = 0;

	@Output() public progrssChange = new EventEmitter<boolean>();

	public lineChartColorScheme = {
		domain: ["#2F74FF", "#039914", "#FF6759", "#FFFD77", "#9B77FF", "#5FF6FF", "#A0FF4A", "#FF79D5", "#FF9A41", "#FFD4F6"],
	};

	public lineChartLineInterpolation = shape.curveCatmullRom;

	public factor: number = 1.5;
	public sliderMax: number = 3;
	public sliderMin: number = 1;
	public sliderStep: number = 0.1;

	constructor(
		protected change: ChangeDetectorRef,
		protected matDialog: MatDialog,
		public shotscore: ShotScoreService,
		protected snackbar: MatSnackBar,
		private router: Router,
		public translate: TranslateService
	) {
		super();
		this.translate.onLangChange.subscribe((_event: Event) => {
			this.draw(this.shots);
		});
	}

	/**
	 * @returns none
	 */
	private messageDialog(title: string, message: string, code: string, callback: (result: any) => void = (result:any) => {}): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
			width: "30%",
			minWidth: "320px",
			height: "fit-content",
			data: {content: {title: "", message: message}},
			disableClose: true,
		});

		dialog.afterClosed().subscribe((result: any): void => {
			callback(result);
		});
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error:IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 * todo
	 */
	private percent(value: number, rate: number): number {
		let result = 0;
		if (value !== 0) {
			result = ((value / 100) * rate);
		}
		return result;
	}

	/**
	 * todo
	 */
	private line(name: string, point: any): object {
		return {
			name,
			series: [
				{
					name: "AD",
					value: Math.floor((point.address.metrics * 1)),
				},
				{
					name: "HB",
					value: Math.floor((point.backswing.metrics * 1)),
				},
				{
					name: "TP",
					value: Math.floor((point.top.metrics * 1)),
				},
				{
					name: "HD",
					value: Math.floor((point.halfdown.metrics * 1)),
				},
				{
					name: "IM",
					value: Math.floor((point.impact.metrics * 1)),
				},
				{
					name: "HF",
					value: Math.floor((point.follow.metrics * 1)),
				},
				{
					name: "FN",
					value: Math.floor((point.finish.metrics * 1)),
				},
			],
		};
	}

	/**
	 * todo
	 */
	private name_to_index(name: string): number {
		let result: number = 0;
		switch (name) {
			case "前傾角度":
				result = 0;
				break;
			case "背骨の傾き":
				result = 2;
				break;
			case "首元の動き":
				result = 5;
				break;
			case "右腰の動き":
				result = 3;
				break;
			case "左腰の動き":
				result = 4;
				break;
			case "重心の動き_正面":
				result = 1;
				break;
			case "右膝の角度":
				result = 6;
				break;
			case "手元の浮き":
				result = 7;
				break;
			case "左膝の角度":
				result = 8;
				break;
			case "頭の動き":
				result = 9;
				break;
			case "両肩の傾き_正面":
				result = 10;
				break;
			case "重心の動き_後方":
				result = 11;
				break;
			case "グリップ位置":
				result = 12;
				break;
			case "手首軌道":
				result = 13;
				break;
			case "腰の開き":
				result = 14;
				break;
			case "肩の開き":
				result = 15;
				break;
			default:
		}
		return result;
	}

	/**
	 * todo
	 */
	private range(position: string): any {
		let result = {min: 0, max: 100};
		switch (position) {
			case "前傾ライン"    : {
				result = {max: 30, min: -1};
				break;
			}
			case "ネックポジション": {
				result = {max: 10, min: -15};
				break;
			}
			case "センターライン": {
				result = {max: 10, min: -20};
				break;
			}
			case "センターポジション": {
				result = {max: 10, min: -10};
				break;
			}
			case "ライトライン": {
				result = {max: 25, min: -1};
				break;
			}
			case "レフトライン": {
				result = {max: 15, min: -10};
				break;
			}
			case "右膝の角度": {
				result = {max: 50, min: -5};
				break;
			}
			case "左膝の角度": {
				result = {max: 50, min: -5};
				break;
			}
			default:
		}
		return result;
	}

	/**
	 * todo
	 */
	private range_by_phase(phase: string, AD: number, club: number): { min: number, max: number }[] {

		const W1 = this.shotscore.phase_table_1W(AD);
		const W5 = this.shotscore.phase_table_5W(AD);
		const I7 = this.shotscore.phase_table_7I(AD);
		const PW = this.shotscore.phase_table_PW(AD);

		const table: any = [
			W1, W1, W1, W5, W1, I7, I7, I7, I7, I7, I7, I7, I7, PW, I7, I7, I7
		];
		return table[club][phase];
	}

	/**
	 * todo
	 */
	private range_par_phase(key: string, phase: string, AD: number, club: number): { min: number, max: number } {
		const range: { min: number, max: number }[] = this.range_by_phase(phase, AD, club);
		return range[this.name_to_index(key)];
	}

	/**
	 * todo
	 */
	private criterion_range(point: any, key: string, club: number): object {

		const AD: number = Math.floor(point.address.metrics * 1);

		return {
			name: "AIGIAライン",
			series: [
				{
					name: "AD",
					value: (this.range_par_phase(key, "AD", AD, club).min + this.range_par_phase(key, "AD", AD, club).max) / 2,
					min: this.range_par_phase(key, "AD", AD, club).min,
					max: this.range_par_phase(key, "AD", AD, club).max,
				},
				{
					name: "HB",
					value: (this.range_par_phase(key, "HB", AD, club).min + this.range_par_phase(key, "HB", AD, club).max) / 2,
					min: this.range_par_phase(key, "HB", AD, club).min,
					max: this.range_par_phase(key, "HB", AD, club).max,
				},
				{
					name: "TP",
					value: (this.range_par_phase(key, "TP", AD, club).min + this.range_par_phase(key, "TP", AD, club).max) / 2,
					min: this.range_par_phase(key, "TP", AD, club).min,
					max: this.range_par_phase(key, "TP", AD, club).max,
				},
				{
					name: "HD",
					value: (this.range_par_phase(key, "HD", AD, club).min + this.range_par_phase(key, "HD", AD, club).max) / 2,
					min: this.range_par_phase(key, "HD", AD, club).min,
					max: this.range_par_phase(key, "HD", AD, club).max,
				},
				{
					name: "IM",
					value: (this.range_par_phase(key, "IM", AD, club).min + this.range_par_phase(key, "IM", AD, club).max) / 2,
					min: this.range_par_phase(key, "IM", AD, club).min,
					max: this.range_par_phase(key, "IM", AD, club).max,
				},
				{
					name: "HF",
					value: (this.range_par_phase(key, "HF", AD, club).min + this.range_par_phase(key, "HF", AD, club).max) / 2,
					min: this.range_par_phase(key, "HF", AD, club).min,
					max: this.range_par_phase(key, "HF", AD, club).max,
				},
				{
					name: "FN",
					value: (this.range_par_phase(key, "FN", AD, club).min + this.range_par_phase(key, "FN", AD, club).max) / 2,
					min: this.range_par_phase(key, "FN", AD, club).min,
					max: this.range_par_phase(key, "FN", AD, club).max,
				},
			],
		};
	}

	/**
	 * todo
	 */
	private max(chart: any): number {
		let max: number = 0;
		chart.data.forEach((line: any): void => {
			line.series.forEach((data: any): void => {
				if (max < data.value) {
					max = data.value;
				}
			});
		});
		return max;
	}

	/**
	 * todo
	 */
	private min(chart: any): number {
		let min: number = Number.MAX_VALUE;
		chart.data.forEach((line: any): void => {
			line.series.forEach((data: any): void => {
				if (min > data.value) {
					min = data.value;
				}
			});
		});
		return min;
	}

	/**
	 * todo
	 */
	private step(chart: any): number {
		return 0.5;
	}

	/**
	 * todo
	 */
	public ngOnInit(): void {
		this.modename = "light";
		this.modestyle = {fill: "#000000"};
	}

	/**
	 * todo
	 */
	public ngOnChanges(changes: any): void {
		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "visible":
				case "shots":
				case "criterion":
					if (this.visible) {
						this.draw(this.shots);
					}
					break;
				default:
					break;
			}
		});
	}

	/**
	 * todo
	 */
	public get chartData(): any {
		return this.lineCharts[this.selected];
	}

	/**
	 * todo
	 */
	public nthChartData(index: number): any {
		return this.lineCharts[index];
	}

	/**
	 * todo
	 */
	public underLine(index: number): any {
		let result: any = {height: "4px", width: "100%"};
		if (index === this.selected) {
			result = {height: "4px", width: "100%", "background-color": "#eaba07"};
		}
		return result;
	}

	/**
	 * todo
	 */
	public onResize(event: any): void {
	}

	/**
	 * todo
	 */
	public onSelect(event: any): void {
	}

	/**
	 * todo
	 */
	public onChange(event: any): void {
		this.lineChartsSelected = event.value;
	}

	/**
	 * todo
	 */
	public draw(shots: any[]): void {
		this.Progress(true);
		try {
			this.lineCharts = [];
			if (shots) {
				shots = shots.slice(0, this.maxSelected);

				let count = shots.length;
				const all = count;
				const par_chart: any = {};

				shots.forEach((shot) => { // par shots-mongo.
					if (count > 1) {
						count--;
						const name = shot.username;
						Object.keys(shot.sm).forEach((key) => { // par graph.
							const point = shot.sm[key];
							const par_line = this.line((all - count) + "." + name, point);
							if (!par_chart[key]) {
								par_chart[key] = [];
							}
							par_chart[key].push(par_line);
						});

					} else { // only first time.
						const sorter: any = {};
						const name = shot.username;
						Object.keys(shot.sm).forEach((key) => { // par graph.
							const point = shot.sm[key];
							const par_line = this.line((all) + "." + name, point);
							if (!par_chart[key]) {
								par_chart[key] = [];
							}
							par_chart[key].push(par_line);

							if (this.criterion) {
								if ((key === "前傾角度") || (key === "背骨の傾き") || (key === "右腰の動き") || (key === "左腰の動き") || (key === "首元の動き") || (key === "重心の動き_正面") || (key === "右膝の角度") || (key === "左膝の角度")) {
									const club = shot.platform.description.club;
									const criterion_range = this.criterion_range(point, key, club);
									par_chart[key].push(criterion_range);
								}
							}

							/*手元の浮き?*/

							const chart = {
								lineChartXAxisLabel: "フェーズ",
								lineChartYAxisLabel: "",
								yScaleMax: 0,
								yScaleMin: 0,
								name: key,
								tag: "",
								data: par_chart[key],
							};

							chart.lineChartYAxisLabel = "(" + point.address.unit + ")";

							const factor = this.factor;

							switch (key) {
								case "前傾角度":
									chart.name = this.translate.instant("前傾ライン");
									chart.tag = "前傾";
									chart.yScaleMax = this.range(chart.name).max * factor; //  this.max(chart) * factor;
									chart.yScaleMin = this.range(chart.name).min * factor; //  this.min(chart) * factor;
									sorter[0] = chart;
									break;
								case "首元の動き":
									chart.name = this.translate.instant("ネックポジション");
									chart.tag = "首元";
									chart.yScaleMax = this.range(chart.name).max * factor; //  this.max(chart) * factor;
									chart.yScaleMin = this.range(chart.name).min * factor; //  this.min(chart) * factor;
									sorter[5] = chart;
									break;
								case "背骨の傾き":
									chart.name = this.translate.instant("センターライン");
									chart.tag = "背骨";
									chart.yScaleMax = this.range(chart.name).max * factor; //  this.max(chart) * factor;
									chart.yScaleMin = this.range(chart.name).min * factor; //  this.min(chart) * factor;
									sorter[2] = chart;
									break;
								case "重心の動き_正面":
									chart.name = this.translate.instant("センターポジション");
									chart.tag = "重心";
									chart.yScaleMax = this.range(chart.name).max * factor; //  this.max(chart) * factor;
									chart.yScaleMin = this.range(chart.name).min * factor; //  this.min(chart) * factor;
									sorter[1] = chart;
									break;
								case "右腰の動き":
									chart.name = this.translate.instant("ライトライン");
									chart.tag = "右腰";
									chart.yScaleMax = this.range(chart.name).max * factor; //  this.max(chart) * factor;
									chart.yScaleMin = this.range(chart.name).min * factor; //  this.min(chart) * factor;
									sorter[3] = chart;
									break;
								case "左腰の動き":
									chart.name = this.translate.instant("レフトライン");
									chart.tag = "左腰";
									chart.yScaleMax = this.range(chart.name).max * factor; //  this.max(chart) * factor;
									chart.yScaleMin = this.range(chart.name).min * factor; //  this.min(chart) * factor;
									sorter[4] = chart;
									break;
								case "右膝の角度":
									chart.name = this.translate.instant("右膝の角度");
									chart.tag = "右膝";
									chart.yScaleMax = this.range(chart.name).max * factor; //  this.max(chart) * factor;
									chart.yScaleMin = this.range(chart.name).min * factor; //  this.min(chart) * factor;
									sorter[6] = chart;
									break;
								case "左膝の角度":
									chart.name = this.translate.instant("左膝の角度");
									chart.tag = "左膝";
									chart.yScaleMax = this.range(chart.name).max * factor; //  this.max(chart) * factor;
									chart.yScaleMin = this.range(chart.name).min * factor; //  this.min(chart) * factor;
									sorter[7] = chart;
									break;
								default:
									break;
							}
						});

						for (let index = 0; index < Object.keys(sorter).length; index++) {
							this.lineCharts.push(sorter[index]);
						}
					}
				});
			} else {
				// Todo: error code messege
			}
		} catch (error) {

		} finally {
			this.Progress(false);
		}
	}

	/**
	 * todo
	 */
	public sliderChange(): void {
		this.draw(this.shots);
	}

	/**
	 * todo
	 */
	public up(): void {
		this.factor = this.factor / 1.4;
		this.draw(this.shots);
	}

	/**
	 * todo
	 */
	public down(): void {
		this.factor = this.factor * 1.4;
		this.draw(this.shots);
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

	/**
	 * @returns style
	 */
	public maxSize(): any {
		return {height: "fit-content", width: this.size[0] + 200 + "px"};
	}

}
